var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-storefront max-w-2xl mx-auto"},[_c('cart-query',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var isLoading = ref.isLoading;
var cart = ref.data;
return [(isLoading)?_c('loading-page'):(cart)?_c('product-browser',{attrs:{"cart":cart}}):_c('el-alert',{attrs:{"type":"error","title":"Ad Shop Error"}},[_vm._v(" Failed to load your cart for the Ad Shop. Please contact us for more information ")])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }